import { Spinner as BaseSpinner } from './Spinner'
import { SpinnerFlex } from './SpinnerFlex'

export const Spinner = Object.assign(BaseSpinner, {
  Flex: SpinnerFlex,
})
